import axios from "axios"
import { useState } from "react"
import { Data } from "~/types/dataTypes"

const emptyFieldErrors = {}

export const useRecruiterForm = (projectPrefix: string) => {
  const [data, setData] = useState<Data>({})
  const [status, setStatus] = useState<
    "pending" | "loading" | "submitted" | "fieldErrors" | "error" | "ineligible"
  >()
  const [fieldErrors, setFieldErrors] =
    useState<Record<string, string>>(emptyFieldErrors)

  const reset = () => {
    setData({})
    setStatus("pending")
  }

  const submitRecruiterForm = async () => {
    setStatus("loading")
    setFieldErrors(emptyFieldErrors)

    try {
      const response = await axios.post(
        `/recruiter/${projectPrefix}`,
        { submission: data },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      setStatus("submitted")
      return response.data
    } catch (err) {
      if (!axios.isAxiosError(err)) {
        setStatus("error")
        return
      }

      const fieldErrors = err.response?.data?.field_errors
      if (fieldErrors) {
        setFieldErrors(fieldErrors)
        setStatus("fieldErrors")
        return
      }

      if (err.response?.data?.status === "ineligible") {
        setStatus("ineligible")
        return
      }

      setStatus("error")
    }
  }

  return {
    submit: submitRecruiterForm,
    status,
    fieldErrors,
    data,
    setData,
    reset
  }
}
